/*
 * File: MonthlyBarChart.tsx
 * Project: a-a
 * File Created: Wednesday, 18th June 2025 7:41:45 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 9th September 2025 9:39:26 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Skeleton, Typography, useTheme } from '@mui/material';
import React from 'react';
import zeplinColor from '../../../../../theme/Color';
import CustomCard from '../../../../shared/CustomCard/CustomCard';
import { BarChart, ChartsTooltipContainer, useAxesTooltip, useItemTooltip } from '@mui/x-charts';

const pData = [2400, 1398, 9800, 3908, 4800, 3800, 4300];
const xLabels = ['Page A', 'Page B', 'Page C', 'Page D', 'Page E', 'Page F', 'Page G'];

const CustomItemTooltip = () => {
  const tooltipData = useItemTooltip();
  console.log({ tooltipData });
  // In this demo only one axis id used.
  // const firstAxisData = tooltipData?.[0];
  // if (!firstAxisData) {
  //   return null;
  // }
  return (
    <Typography variant='label1' color={zeplinColor.Neutral1}>
      {/* {firstAxisData?.axisFormattedValue.charAt(0).toUpperCase() +
        firstAxisData?.axisFormattedValue.slice(1)}{' '}
      {'-'} {firstAxisData?.seriesItems[0]?.formattedValue} */}
    </Typography>
  );
};
const formatYAxisValue = (value: number): string => {
  console.log({ value });
  if (value >= 1000000000) {
    return `${(value / 1000000000).toFixed(1).replace(/\.0$/, '')}B`;
  }
  if (value >= 1000000) {
    return `${(value / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  }
  if (value >= 1000) {
    return `${(value / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  }
  return value.toString();
};

const MonthlyBarChart = ({
  title,
  total,
  percent,
  data,
  chartKey,
  loading,
}: {
  title: string;
  total: string;
  percent: number;
  data: any;
  chartKey: string;
  loading: boolean;
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        borderRadius: '14px',
        padding: { xs: '12px', xl: '16px' },
        border: `1px solid ${zeplinColor.Neutral5}`,
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant='heading3'>{title}</Typography>
        <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
          {/* <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
            <Typography variant='label1' color={zeplinColor.Neutral8}>
              Total
            </Typography>
            <Typography variant='heading4'>{total}</Typography>
          </Box>
          {typeof percent === 'number' ? (
            <CustomCard
              styles={{
                borderRadius: '50px',
                padding: '4px 8px',
                backgroundColor: percent < 0 ? zeplinColor.Error : zeplinColor.Success,
                // width: '509px',
                height: '22px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Typography variant='label1' color={zeplinColor.Neutral1}>
                {`${percent < 0 ? '' : '+'} ${percent?.toFixed(2)}`}%
              </Typography>
            </CustomCard>
          ) : (
            <Skeleton
              variant='text'
              sx={{
                fontSize: theme.typography.body2,
                width: '100%',
                // Optionally adjust other styles here
              }}
            />
          )} */}
        </Box>
      </Box>
      {loading ? (
        <Box
          sx={{
            display: 'flex',
            // justifyContent: 'space-between',
            marginTop: '10%',
            alignItems: 'center',
            gap: '10rem',
          }}
        >
          {/* <Skeleton variant='circular' width={40} height={40} /> */}
          <Skeleton
            variant='text'
            sx={{
              fontSize: theme.typography.body2,
              width: '100%',
            }}
          />
        </Box>
      ) : (
        <Box sx={{ position: 'relative' }}>
          <BarChart
            height={300}
            series={[
              {
                data:
                  typeof data === 'object'
                    ? Object.keys(data?.platforms)?.length &&
                      data?.platforms?.map((val: any) => val[chartKey])
                    : [],
                id: 'pvId',
              },
            ]}
            xAxis={[
              {
                scaleType: 'band',
                data:
                  typeof data === 'object'
                    ? Object.keys(data?.platforms)?.length &&
                      data?.platforms?.map(
                        (val: any) => val?.platform[0].toUpperCase() + val?.platform?.slice(1),
                      )
                    : [],
                disableLine: true,
                disableTicks: true,
                categoryGapRatio: 0.8,
              },
            ]}
            yAxis={[
              {
                width: 50,
                disableLine: true,
                disableTicks: true,
                valueFormatter: formatYAxisValue,
              },
            ]}
            grid={{ horizontal: true, vertical: false }}
            sx={{
              '.MuiChartsGrid-horizontalLine': {
                stroke: zeplinColor.Neutral5,
                strokeDasharray: '5 5',
              },
            }}
            borderRadius={4}
            slots={
              {
                // tooltip: (props, val) => {
                //   return (
                //     <ChartsTooltipContainer
                //       trigger='item'
                //       style={{
                //         backgroundColor: zeplinColor.BasicBlack,
                //         borderRadius: '8px',
                //         padding: '4px',
                //       }}
                //     >
                //       <CustomItemTooltip />
                //     </ChartsTooltipContainer>
                //   );
                // },
              }
            }
          />
          <Box
            sx={{
              position: 'absolute',
              top: '30%',
              bottom: 0,
              left: 0,
              right: 0,
              height: '300px',
              margin: 'auto',
            }}
          >
            <Box
              sx={{
                width: '50%',
                // height: '50%',
                margin: 'auto',
              }}
            >
              {typeof data?.platforms === 'object' && Object.keys(data?.platforms)?.length < 0 && (
                <Box
                  sx={{
                    width: '80%',
                    display: 'flex',
                    backgroundColor: zeplinColor.Neutral1,
                    flexDirection: 'column',
                    gap: '24px',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <img src={'/assets/no-chart.svg'} width={'36px'} height={'36px'} alt='no-chart' />
                  <Box
                    sx={{
                      display: 'flex',
                      gap: '12px',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                    }}
                  >
                    <Typography variant='heading3'>No Data Available</Typography>
                    <Typography variant='body3' color={zeplinColor.Neutral8}>
                      There’s no data to display right now. Data will appear here automatically once
                      available.
                    </Typography>
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default MonthlyBarChart;
